export default __webpack_public_path__ + "static/media/VoluntaryLifeInsurance.dfa8cb35.svg";